import { toast } from "react-toastify";
import i18n from "i18n";

export const ErrorToaster = (message = i18n.t("common:toast.failed")) => {
  toast.dismiss();
  toast.error(message, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

export const successToaster = (message = i18n.t("common:toast.success")) => {
  toast.dismiss();
  toast.success(message, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

export const warningToaster = (message = i18n.t("common:toast.success")) => {
  toast.dismiss();
  toast.warning(message, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

export const infoToaster = (message = i18n.t("common:toast.success")) => {
  toast.dismiss();
  toast.info(message, {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
